import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import  Sidebar from "./Sidebar";




class Certificate extends Component {
  render() {
    return (
    <div> 
      <section className="inner-intro bg-image  parallax parallax-background1 inner_page_background" style={{backgroundImage:'url("/assets/img/images/usine_agro.png")'}}>
            <div className="container">
                <div className="row title">
                    <h2 className="h2">Green Agro Business</h2>
                    <div className="page-breadcrumb">
                        <a>Nos Produits</a>/<span>Certification Bio</span>
                    </div>
                </div>
            </div>
        </section>   
   <section id="about" className="wow fadeIn ptb ptb-sm-80">
            <div className="container filigrane page_info">
                <div className="row text-center inside_content">
                    <div className="col-md-8">
                    <h3><img src="/assets/img/leaf.png" className="leaf-sidebar"/>Certification Bio</h3>
                    
                </div>
                <Sidebar/> 
            
            </div>
              </div>
        </section>
<hr />

    </div>
       
        

    )
  }
}
export default Certificate;


// WEBPACK FOOTER //
// ./src/components/certification.jsx